<template>
  <div class="contain">
    <el-form
      :model="inputForm"
      :label-width="$device.mobile ? `` : `140px`"
      label-suffix=":"
      :size="size"
      @submit.native.prevent>
      <el-row>
        <el-col :md="12">
          <el-form-item :label="$t('사업장 코드')">
            <span class="show_cd">{{ inputForm.custId }}</span>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item :label="$t('사업장명')" :error="formError.custNm" required>
            <el-input v-model="inputForm.custNm" maxlength="50" clearable show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item :label="$t('사업자 등록 번호')" :error="formError.busiNum">
            <el-input
              v-keep-number-caret
              :value="util.bizNoFieldText(inputForm.busiNum)"
              maxlength="20"
              clearable
              show-word-limit
              @input="inputForm.busiNum = util.bizNoInputValue($event)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item :label="$t('대표자명')" :error="formError.ceoNm" required>
            <el-input v-model="inputForm.ceoNm" maxlength="20" clearable show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <ceo-verification-line :block="inputForm.ceoVerification"></ceo-verification-line>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item :label="$t('전화번호')" :error="formError.tel" required>
            <el-input
              v-keep-number-caret
              :value="util.telFieldText(inputForm.tel)"
              maxlength="20"
              clearable
              show-word-limit
              @input="inputForm.tel = util.telDigits($event)"></el-input>
          </el-form-item>
        </el-col>
        <!--					<el-col :md="12">-->
        <!--						<el-form-item :label="$t('팩스번호')" :error="formError.fax">-->
        <!--							<el-input :value="util.telFieldText(inputForm.fax)" maxlength="20" clearable show-word-limit @input="inputForm.fax = util.telDigits($event)"></el-input>-->
        <!--						</el-form-item>-->
        <!--					</el-col>-->
        <el-col :md="12">
          <el-form-item :label="$t('이메일')" :error="formError.email" required>
            <el-input v-model="inputForm.email" maxlength="50" clearable show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item :label="$t('가입일')">
            <span>{{ inputForm.startDt }}</span>
          </el-form-item>
        </el-col>
        <!-- 					<el-col :md="12"> -->
        <!-- 						<el-form-item :label="$t('탈퇴일')"> -->
        <!-- 							<span>{{ inputForm.endDt }}</span> -->
        <!-- 						</el-form-item> -->
        <!-- 					</el-col> -->
      </el-row>
      <!--				<el-row >-->
      <!--					<el-col :md="12">-->
      <!--						<el-form-item :label="$t('정산은행')" :error="formError['bankTp.cd']">-->
      <!--							<code-combo :data="bankTp" :model="inputForm.bankTp" @change="inputForm.bankTp = $event"></code-combo>-->
      <!--						</el-form-item>-->
      <!--					</el-col>-->
      <!--				</el-row>-->
      <!--				<el-row >-->
      <!--					<el-col :md="12">-->
      <!--						<el-form-item :label="$t('정산계좌번호')" :error="formError.accountNumber">-->
      <!--							<el-input v-model="inputForm.accountNumber" maxlength="20" clearable show-word-limit @keyup.native="inputForm.accountNumber = util.inputBusiNumNew($event)"></el-input>-->
      <!--						</el-form-item>-->
      <!--					</el-col>-->
      <!--					<el-col :md="12">-->
      <!--						<el-form-item :label="$t('예금주명')" :error="formError.accountName">-->
      <!--							<el-input v-model="inputForm.accountName" maxlength="20" clearable show-word-limit></el-input>-->
      <!--						</el-form-item>-->
      <!--					</el-col>-->
      <!--				</el-row>-->
      <el-row>
        <el-col :md="12">
          <el-form-item :label="$t('우편 번호')" :error="formError.zipCd" required>
            <el-input v-model="inputForm.zipCd" maxlength="10" show-word-limit style="width: 200px" readonly></el-input>
            <el-button @click="selectAddress()">{{ $t('주소 조회') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="12">
          <el-form-item :label="$t('주소')" :error="formError.addr" required>
            <el-input v-model="inputForm.addr" maxlength="250" clearable show-word-limit readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item :label="$t('상세 주소')" :error="formError.addrDtl" required>
            <el-input ref="addr_dtl" v-model="inputForm.addrDtl" maxlength="50" clearable show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--				<el-row >-->
      <!--					<el-col :md="24">-->
      <!--						<el-form-item :label="$t('설명')" :error="formError.custDesc">-->
      <!--							<el-input v-model="inputForm.custDesc" type="textarea" maxlength="250" show-word-limit></el-input>-->
      <!--						</el-form-item>-->
      <!--					</el-col>-->
      <!--				</el-row>-->
      <!--				<el-row >-->
      <!--					<el-col :md="8">-->
      <!--						<el-form-item :label="$t('첨부 파일')">-->
      <!--							<el-upload
                        action="" class="avatar-uploader" accept="image/*" :auto-upload="false" :file-list="inputForm.files"-->
      <!--								:on-change="custFileAdd" :on-remove="custFileRemove" multiple list-type="picture">-->
      <!--								<el-button slot="trigger" size="small" type="primary" >{{ $t('파일 추가') }}</el-button>-->
      <!--							</el-upload>-->
      <!--						</el-form-item>-->
      <!--					</el-col>-->
      <!--					<el-col :md="8">-->
      <!--						<div style="margin-top: 30px;">&nbsp;</div>-->
      <!--						<div v-for="(item, index) in inputForm.files" :key="index" class="file_name"-->
      <!--								style="margin-top: 10px; height: 92px;" v-if="'del' != inputForm.files[index].status">-->
      <!--							<el-input v-model="inputForm.files[index].name" maxlength="50" show-word-limit :size="size"-->
      <!--								type="textarea" resize="none" rows="4" @change="fileNameChange(inputForm.files[index])"></el-input>-->
      <!--						</div>-->
      <!--					</el-col>-->
      <!--				</el-row>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="save" icon="el-icon-check" :size="size" :disabled="btn.saveDisabled">{{
        $t('저장')
      }}</el-button>
    </div>
    <!--
      주문 미수락 자동 취소 — 위 사업장 폼과 **저장이 갈린다**(자기 경로·자기 버튼, `CustOrderAcceptPolicyPanel`).
      폼 안이 아니라 폼의 「저장」 아래에 둔다: 폼 안에 두면 위 「저장」이 이 값까지 저장하는 것처럼 읽히고 폼이 겹친다.
      사업장을 읽기 전(`custCd` 0)에는 가리킬 대상이 없어 그리지 않는다.
    -->
    <CustOrderAcceptPolicyPanel v-if="inputForm.custCd" :cust-cd="inputForm.custCd" />
  </div>
</template>

<script>
// 대리점
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'
import { pickAddress } from '@/utils/addressPicker'
import CustOrderAcceptPolicyPanel from '@/components/customer/CustOrderAcceptPolicyPanel.vue'
import CeoVerificationLine from '@/components/common/CeoVerificationLine.vue'

export default {
  mixins: [mainVueMixin],
  components: { CustOrderAcceptPolicyPanel, CeoVerificationLine },
  data: function () {
    var data = initData()

    data.url = '/cust/info'

    data.bankTp = []

    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.dialogFormVisible = true
    data.btn.saveDisabled = false

    return data
  },
  created: function () {
    this.initBankTp()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'U',
        title: this.$t('사업장 정보'),
        custCd: 0,
        custNm: '',
        busiNum: '',
        ceoNm: '',
        tel: '',
        fax: '',
        email: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        custDesc: '',
        files: [],
        delFiles: [],
        startDt: null,
        endDt: null,
        accountNumber: '',
        bankTp: null,
        accountName: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        custNm: '',
        busiNum: '',
        ceoNm: '',
        tel: '',
        fax: '',
        email: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        custDesc: '',
        startDt: '',
        accountNumber: '',
        'bankTp.cd': '',
        accountName: '',
      }
    },
    // 정산은행구분 조회
    initBankTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/BANK_TP',
        null,
        function (result) {
          this.bankTp = result
          this.up()
        }.bind(this)
      )
    },
    // 수정
    up: function () {
      this.mainVue.$axios.search(
        this.url,
        null,
        function (result) {
          result.delFiles = []

          this.inputForm = result
        }.bind(this),
        false
      )

      this.formError = this.initFormError()
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      var tmp = util.copyObj(this.inputForm.files)

      this.inputForm.files = this.inputForm.files.concat(this.inputForm.delFiles)

      this.mainVue.$axios.up(
        this.url + '/' + this.inputForm.custCd,
        this.inputForm,
        this.formError,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('저장 성공') })

          this.inputForm.files = tmp
        }.bind(this),
        true
      )
    },
    // 첨부 파일 추가
    custFileAdd: function (file, fileList) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data) {
          this.inputForm.files.push({
            url: data,
            name: file.name,
            status: 'ready',
          })
        }.bind(this)
      )
    },
    // 수정 시 업로드 했던 이미지 삭제 시 삭제 리스트에 저장
    custFileRemove: function (file, fileList) {
      var tmp = -1
      for (var i = 0, len = this.inputForm.files.length; i < len; i++) {
        if (this.inputForm.files[i].url == file.url) {
          tmp = i
        }
      }

      if (tmp > -1) {
        this.inputForm.files.splice(tmp, 1)
      }

      if (file.status == 'success') {
        file.status = 'del'
        this.inputForm.delFiles.push(file)
      }
    },
    fileNameChange: function (file) {
      if ('ready' != file.status) {
        file.status = 'change'
      }
    },
    /**
     * 주소 선택 — 위젯은 `utils/addressPicker` 한 곳이 만진다(종전 `initDaum` 다섯 사본을 접었다).
     * 채우는 필드(우편번호·주소)와 포커스 이동은 종전 그대로다.
     */
    selectAddress: async function () {
      let picked = null
      try {
        picked = await pickAddress({ geocode: false })
      } catch (error) {
        this.$message({ type: 'error', message: error.message })

        return
      }
      if (!picked) return

      this.inputForm.zipCd = picked.zonecode
      this.inputForm.addr = picked.address

      this.$refs.addr_dtl.focus()
    },
  },
}
</script>

<style scoped>
.el-dialog__header {
  padding: 0 !important;
}

.el-upload-list__item {
  -webkit-transition: none;
  transition: none;
}

.file_name .el-textarea__inner {
  height: 90px;
}
</style>
